import React from 'react';
import { inject } from 'mobx-react';
import { NotFoundTemplate } from 'themes/modules/root/pages';

@inject(i => ({
	rootStore: i.rootStore,
}))
class NotFound extends React.Component {
	render() {
		return <NotFoundTemplate {...this.props} />;
	}
}

export default NotFound;
